import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ListItem } from '../../../core/models/liste.model';
import { FormulaireContact } from '../../models/formulaire.model';
import { FormulaireContactService } from '../../services/formulaireContact.service';


@Component({
    selector: 'formulaire-contact',
    styleUrls: ['./formulaireContact.component.css'],
    templateUrl: './formulaireContact.component.html'
})
export class FormulaireContactComponent implements OnInit {
    form: FormulaireContact;
    listeNature: ListItem[] = [];
    listeTheme: ListItem[] = [];
    errors: Array<string>;
    retourOK: boolean = false;
    retourKO: boolean = false;
    loading: boolean = false;
    sizeMax: boolean = false;
    extensionsAuthorized :string[]=['pdf', 'gif', 'jpg', 'jpeg', 'png', 'bmp', 'xls', 'xlsx', 'ppt', 'doc', 'docx'];
    extenstionResult:boolean=true;
    timeOut: boolean = true;

    constructor(private _formulaireContactService: FormulaireContactService) {}

    async ngOnInit() {
        this.form = new FormulaireContact();
        this.loading = false;
    }

    onChange(file: File) {
      
        this.sizeMax = false;
        this.form.file = file;
        this.sizeMax = (file.size > 5242880);
        this.extenstionResult=this.checkFileExtension(file.name.substring(file.name.lastIndexOf('.')+1).toLowerCase());

    }

    async onSubmit(contactForm: NgForm,$event: any) {
       
        this.retourOK = false;
        this.retourKO = false;
        this.markAsTouchedAllFields(contactForm);
        if (!contactForm.valid || this.sizeMax || !this.extenstionResult) return;
        
        try {
            let response = await this._formulaireContactService.createIncident(this.form);
            this.form = new FormulaireContact();
            contactForm.resetForm();
            this.retourOK = true;
            this.timeOut = true;
            setTimeout(() => this.timeOut = false, 2000);
            this.retourKO = false;
        } catch (error) {
            this.retourOK = false;
            this.retourKO = true;
            setTimeout(() => this.timeOut = false, 2000);
            this.retourKO = true;
        }
    }

    markAsTouchedAllFields(contactForm: NgForm) {
     
        Object.keys(contactForm.controls).forEach(field => {
            const control = contactForm.controls[field];
            control.markAsTouched({ onlySelf: true });
        });
    }


    showErrorMessage(contactForm: NgForm,field: string) {
        let control = contactForm.controls[field];
        if (!control)
            return false;
        return !control.valid && (control.dirty || control.touched);
    }

    checkFileExtension(extension:string)
    {
      if(this.extensionsAuthorized.indexOf(extension)>= 0)
      {
          return true;
      }
      return false;
    }

}
